import React from "react";
import { IT } from "../../../consts";
import GoogleStrategy from "./../../calendar/strategies/GoogleStrategy";

const IntegrationContext = React.createContext("");

const StragiesMappping = {
  [IT.google]: GoogleStrategy,
};
/**
 *
 * @param integrationName
 * @returns {CalendarIntegrationStrategy}
 */
export const getStrategy = (integrationType, widget) => {
  if (!StragiesMappping[integrationType]) {
    return null;
  }
  return new StragiesMappping[integrationType](widget);
};

export default IntegrationContext;
